import React, {useEffect} from "react";
import axios from "axios";
import {appdata, load, save} from "../../logic_tmp/appdata/AppData";
import queryString from "query-string";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {calcHeader} from "../model/utils";
import {MySpinner} from "../common/MySpinner";

export function Continue() {
    const history = useHistory()
    const {t} = useTranslation();

    function redirect() {
        const queryParams = queryString.parse(window.location.search)

        axios.get('https://api.duoclassico.eu/functions/getReservation?reservationId=' + queryParams["orderId"])
            .then(async response => {
                if (response.data["reservationStatus"] == "USED") {
                    history.push("/usedlink")
                    return;
                }
                window.localStorage.setItem('state', JSON.stringify(response.data));
                load()
                axios("https://duopaysetup.s3.eu-west-1.amazonaws.com/" + appdata.productCode + "/" + appdata.productCode + ".json").then(
                    resp => {
                        appdata.product = resp.data;
                        axios.post('https://api.duoclassico.eu/functions/lead', appdata)
                            .then(response => {
                                    if (response.status !== 200) {
                                        this.setState({error: response.statusText});
                                        return;
                                    }
                                    appdata.country = response.data["country"];
                                    calcHeader(t)
                                    save();
                                    if (appdata.amount === 0) {
                                        history.push("/ok")
                                    } else
                                        history.push("/payment")
                                }
                            )
                    }
                )
            })
            .catch((error) => {
                return Promise.reject(error)
            })
            .finally(() => {

            });
    }

    useEffect(() => {
        redirect();
    }, [])


    return (
        <div>
            <MySpinner/>
        </div>
    )
}


